import React, { createContext, useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import moment from "moment/moment";
import HeadBar from "./component/header/Menu";

import {
  publicRouteWithLayout,
  patientsRouteWithLayout,
  medicalRouteWithLayout,
  adminRouteWithLayout,
  operationRoomRouteLayout,
  executiveRouteWithLayout,
  hospitalRouteWithLayout,
  hospitalPersonnelRouteWithLayout,
  get404Route,
} from "./Routes"; //จะมี อีก 4 router path  คือ หมอ คนไข้หรือผู้ใช้งานทั่วไป แอดมินเล็ก แอดมินใหญ่
import DialogTailwind from "./component/DialogTailwind";
import DialogTailwindConfirm from "./component/DialogTailwindConfirm";
import PopupNotification from "./component/PopupNotification";
import Footer from "./component/public/footer/Footer";
// import PopupNotification from "../popupNotification";

export const CurrentUserContext = createContext(null);

function isMobileOrTablet() {
  const ua = navigator.userAgent;
  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) return true;
  if (/iPad/i.test(ua)) return true;
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return true;
  if (window.innerWidth <= 1024) return true;
  return false;
}

function MiniAppDesktopBlock() {
  return (
    <div style={{
      minHeight: "100vh", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center", background: "#f9fafb", padding: "2rem", textAlign: "center"
    }}>
      <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>📱</div>
      <p style={{ fontSize: "1.25rem", fontWeight: 700, color: "#374151", marginBottom: "0.5rem" }}>
        รองรับเฉพาะ Mobile และ iPad เท่านั้น
      </p>
      <p style={{ fontSize: "0.875rem", color: "#9ca3af" }}>
        กรุณาเปิดผ่านแอปพลิเคชัน หมอพร้อม บนโทรศัพท์มือถือหรือแท็บเล็ต
      </p>
    </div>
  );
}

function AppShell({ routerPublic, routerList }) {
  const location = useLocation();
  const isMiniApp = location.pathname.startsWith("/miniapp");

  if (isMiniApp && !isMobileOrTablet() && location.pathname !== "/miniapp/404") {
    return <MiniAppDesktopBlock />;
  }

  return (
    <>
      {!isMiniApp && <HeadBar />}
      <Routes>
        {routerPublic.length > 0 &&
          routerPublic.map((item, index) => (
            <Route key={index} path={item.path} element={item.component} />
          ))}
        {routerList.length > 0 &&
          routerList.map((item, index) => (
            <Route key={index} path={item.path} element={item.component} />
          ))}
        {get404Route()}
      </Routes>
      {!isMiniApp && <Footer />}
    </>
  );
}

const getInitialRoutes = (user) => {
  if (!user) return [];
  const role = user?.["auth"]?.["role"]?.[0];
  switch (role) {
    case "PATIENT":
      return patientsRouteWithLayout;
    case "MEDICAL_PERSONNEL":
      return medicalRouteWithLayout;
    case "LABORATORY_PERSONNEL":
    case "LABORATORY_ADMIN":
      return operationRoomRouteLayout;
    case "ADMIN":
      return adminRouteWithLayout;
    case "EXECUTIVE":
      return executiveRouteWithLayout;
    case "HOSPITAL":
      return hospitalRouteWithLayout;
    case "HOSPITAL_PERSONNEL":
      return hospitalPersonnelRouteWithLayout;
    default:
      return [];
  }
};

function App() {
  const [pathConditionRoute, setPathConditionRoute] = useState("");
  const [routerPublic, setRouterPublic] = useState(publicRouteWithLayout); // path ที่เข้าถึงได้ทุกคน เปิดตลอด
  const [userRole, setUserRole] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const [routerList, setRouterList] = useState(() =>
    getInitialRoutes(userRole),
  ); // path ที่เข้าถึงได้จากการ login เท่านั้น
  const [isMessage, setIsMessage] = useState("");
  const [isMessageConnfirm, setIsMessageConfirm] = useState("");
  // const [notification, setNotification] = useState({
  //   type: "",
  //   msg: "",
  // });

  useEffect(() => {
    //นี้คือฟังค์ชั่นไว้เข้าถึง component path เฉพาะ อาจจะต้องมา มีasny function การเข้าถึง แต่ละส่วน แล้ว condition ตัวอย่าง if(....) {   setRouterList(พาร์ทที่ต้องการจะให้มีในweb) } ได้เลย เพื่อป้องกันการเข้าถึงแบบไม่ถูกต้อง (hack)

    setRouterPublic(publicRouteWithLayout);
  }, []);

  useEffect(() => {
    if (userRole === null) {
    } else {
      const tokenExpireAuth = localStorage.getItem("expire_login_user");
      if (checkExpireToken(tokenExpireAuth)) {
      } else {
        setIsMessage({ type: "error", data: "หมดเวลาใช้งาน" });
        localStorage.clear();
        window.location.assign("/login");
        return;
      }
    }
    // console.log('log จาก useEffect tokenExpireAuth')
  }, [userRole]);

  useEffect(() => {
    if (userRole === null) {
    } else {
      const role = userRole?.["auth"]["role"][0];
      if (role === "PATIENT") {
        setRouterList(patientsRouteWithLayout);
      } else if (role === "MEDICAL_PERSONNEL") {
        setRouterList(medicalRouteWithLayout);
      } else if (role === "LABORATORY_PERSONNEL") {
        setRouterList(operationRoomRouteLayout);
      } else if (role === "LABORATORY_ADMIN") {
        setRouterList(operationRoomRouteLayout);
      } else if (role === "ADMIN") {
        setRouterList(adminRouteWithLayout);
      } else if (role === "EXECUTIVE") {
        setRouterList(executiveRouteWithLayout);
      } else if (role === "HOSPITAL") {
        setRouterList(hospitalRouteWithLayout);
      } else if (role === "HOSPITAL_PERSONNEL") {
        setRouterList(hospitalPersonnelRouteWithLayout);
      } else {
        setRouterList([]);
      }
    }
  }, [userRole]);

  const checkExpireToken = (expire) => {
    let diff = moment().diff(expire, "seconds");
    if (diff >= 0) {
      return false;
    } else {
      return true;
    }
  };

  const closeNotification = () => {
    setIsMessage("");
  };

  return (
    <>
      {/* {isMessage && (
        <DialogTailwind children={isMessage} initState={setIsMessage} />
      )} */}

      {isMessage && (
        <PopupNotification msg={isMessage} onClose={closeNotification} />
      )}

      {isMessageConnfirm && (
        <DialogTailwindConfirm
          children={isMessageConnfirm}
          initState={setIsMessageConfirm}
        />
      )}

      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <CurrentUserContext.Provider
          value={{
            userRole,
            setUserRole,
            setIsMessage,
            setIsMessageConfirm,
          }}
        >
          <AppShell routerPublic={routerPublic} routerList={routerList} />
        </CurrentUserContext.Provider>
      </Router>
    </>
  );
}

export default App;
